import { FC } from 'react';

import { AcademicYearTitle } from 'components/pdfStudent';
import { splitDataWithUnformattedEventDate } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionProforientationRecommendations } from 'icons/widgets';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { proforientationModel } from 'portfolio3/features/proforientation';
import { getCurrentLearningYear, getDataLoadRequests } from 'utils';

import PdfCommonDataEntityContainer from '../common';
import RecommendationExcursionsSection from './proforientation/RecommendationExcursionsSection';
import RecommendationOpenDaySection from './proforientation/RecommendationOpenDaySection';
import RecommendationProbesSection from './proforientation/RecommendationProbesSection';
import RecommendationProforientationSection from './proforientation/RecommendationProforientationSection';

import '../index.scss';

const PdfProforientationRecommendations: FC = () => {
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionProforientation });
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const probes = useAppSelector(proforientationModel.selectors.proforientationRecommendationSelectors.probes);
  const excursions = useAppSelector(proforientationModel.selectors.proforientationRecommendationSelectors.excursions);
  const dods = useAppSelector(proforientationModel.selectors.proforientationRecommendationSelectors.dods);

  const recommendedIndustries = useAppSelector(
    proforientationModel.selectors.proforientationRecommendationSelectors.proforientation,
  );
  const hasRecommendedIndustries = recommendedIndustries.length > 0;

  const excursionsAcademicYearData = splitDataWithUnformattedEventDate(excursions, academicYears);
  const probesAcademicYearData = splitDataWithUnformattedEventDate(probes, academicYears);
  const dodsAcademicYearData = splitDataWithUnformattedEventDate(dods, academicYears);
  const currentLearningYear = getCurrentLearningYear();

  const yearsList = new Set([
    ...excursionsAcademicYearData.map(([year, _]) => year),
    ...probesAcademicYearData.map(([year, _]) => year),
    ...dodsAcademicYearData.map(([year, _]) => year),
    /** Если выбран текущий год, то отображаем список специальностей, если они есть */
    ...(academicYears.includes(currentLearningYear) && hasRecommendedIndustries ? [currentLearningYear] : []),
  ]);

  return (
    <PdfCommonDataEntityContainer title="Рекомендации" Icon={IconWidgetProfessionProforientationRecommendations}>
      {Array.from(yearsList).map((academicYear) => {
        const excursionsData = excursionsAcademicYearData.find(([year, _]) => year === academicYear);
        const probesData = probesAcademicYearData.find(([year, _]) => year === academicYear);
        const dodsData = dodsAcademicYearData.find(([year, _]) => year === academicYear);

        return (
          <div key={academicYear}>
            <AcademicYearTitle academicYear={academicYear} />
            {academicYear === currentLearningYear && <RecommendationProforientationSection />}
            {probesData && <RecommendationProbesSection data={probesData[1]} />}
            {excursionsData && <RecommendationExcursionsSection data={excursionsData[1]} />}
            {dodsData && <RecommendationOpenDaySection data={dodsData[1]} />}
          </div>
        );
      })}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfProforientationRecommendations;
